(function($) {
    $(() => {
        $('.js-jarallax').jarallax({
            speed: 0.2,
            //disableParallax: /iPad|iPhone|iPod|Android/
        });

		function setMenu() {
			const nav = $('#menu');
			if ($(window).scrollTop() > 0) {
				nav.addClass('scrolled');
			} else {
				nav.removeClass('scrolled');
			}
		}

		setMenu();

		$(window).scroll(() => {
			setMenu();
		});

        $('.slider').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });

        $('.js-news-slider').slick({
			dots: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            //autoplay: true,
            //autoplaySpeed: 5000
        });

        // Params

        if($('.swiper-container').length) {
			const sliderSelector = '.swiper-container';

			var options = {
				init: false,
				loop: true,
				speed: 800,
				slidesPerView: 4, // or 'auto'
				// spaceBetween: 10,
				centeredSlides: true,
				effect: 'coverflow', // 'cube', 'fade', 'coverflow',
				coverflowEffect: {
					rotate: 0, // Slide rotate in degrees
					stretch: -50, // Stretch space between slides (in px)
					depth: 100, // Depth offset in px (slides translate in Z axis)
					modifier: 1, // Effect multipler
					slideShadows: true // Enables slides shadows
				},
				grabCursor: true,
				parallax: true,
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				},
				breakpoints: {
					1180: {
						slidesPerView: 2
					},
					1023: {
						slidesPerView: 1,
						spaceBetween: 0
					}
				},
				// Events
				on: {
					imagesReady() {
						this.el.classList.remove('loading');
					}
				}
			};
			const mySwiper = new Swiper(sliderSelector, options);

			// Initialize slider
			mySwiper.init();

		}



        ///////////////

		$('.js-form').parsley({
			trigger: 'change',
			successClass: 'is-success',
			errorClass: 'is-error',
			classHandler(el) {
				return el.$element.closest('.form-group');
			},
			errorsWrapper: '<div class="invalid-message error-text"></div>',
			errorTemplate: '<span></span>'
		});

		$('#aniimated-thumbnials').lightGallery({
			thumbnail:false,
			animateThumb: false,
			showThumbByDefault: false,
			download: false,
			counter: false,
			share: false,
			actualSize: false,


		});


	});
})(jQuery);
